module.exports = __webpack_public_path__ + "static/media/qwiky-app-icon.40986b31.png";